import React, { useState, useEffect, useCallback  } from 'react';
import { withTrans } from "@i18n/withTrans";
import { configureAnchors } from 'react-scrollable-anchor';
import { Location } from '@reach/router';
import { PageHeader } from './elements';
import { Header } from './Header';
import { GlobalStyles } from '@helpers/GlobalStyles'
import { ScrollProvider } from '@helpers/provider/ScrollProvider';
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

import '@assets/styles/normalize.css';
import '@assets/styles/bootstrap-grid.min.css';
import '@assets/styles/fonts.css';


const MainContainer = ({ children, t, i18n, pageContext }) => {

  const query = useStaticQuery(graphql`
    {
      site: site {
        siteMetadata {
          defaultLanguage,
          supportedLanguages,
          title
        }
      }
    }
  `)
  const [state, setState] = useState({
    lastScrollTop: 0,
    bodyOffset: 0,
    scrollY: 0,
    scrollDirection: '',
  })

  const handleScrollEvent = useCallback((e) => {
    setState((prevState) => {
      const prevLastScrollTop = prevState.lastScrollTop
      const bodyOffset = document.body.getBoundingClientRect()

      return {
        setBodyOffset: bodyOffset,
        scrollY: -bodyOffset.top,
        scrollDirection: prevLastScrollTop > -bodyOffset.top ? 'up' : 'down',
        lastScrollTop: -bodyOffset.top,
      }
    })
  }, [])

  configureAnchors({offset: -60, scrollDuration: 200});
  
  useEffect(() => {
    const scrollListener = (e) => {
      handleScrollEvent(e)
    }
    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [handleScrollEvent]);

  // useEffect(() => {
  //   i18n.changeLanguage(pageContext.lang)
  // }, [pageContext, i18n])

  return (
    <>
      <Location>
        {props => (
          <Helmet 
            htmlAttributes={{ lang: pageContext.lang}} 
            link={[
              {
                rel: 'canonical',
                href: `${props.location.href}`,
              },
              {
                rel: 'alternate',
                hrefLang: 'x-default',
                href: `${props.location.host}${pageContext.originalPath}`,
              },
              ...query.site.siteMetadata.supportedLanguages.map(supportedLang => ({
                rel: 'alternate',
                hrefLang: supportedLang,
                href: `${props.location.host}${query.site.siteMetadata.defaultLanguage !== supportedLang ? `/${supportedLang}` : ''}${pageContext.originalPath}`,
              })),
            ]}
          >
            <meta charSet="utf-8" />
            <title>{t(`${query.site.siteMetadata.title}`)}</title>
          </Helmet>
        )}
      </Location>
      <GlobalStyles/>
      <main>
        <ScrollProvider.Provider value={state}>
            <Header t={t} i18n={i18n} path="/" scrollDirection={state.scrollDirection} scrollY={state.scrollY} pageContext={pageContext}/>
            <div path="/"className='container'> 
                  <PageHeader path="/">{t("Our Brand: Soft-FX")}</PageHeader>
                  {children}
            </div>
        </ScrollProvider.Provider>
      </main>
    </>
  );
};


export const Main = withTrans(MainContainer);